import CardV from 'src/components/cards/card-v';
import CardH from 'src/components/cards/card-h';
import { FiArrowRightCircle } from 'react-icons/fi';

const SectionHSide = ({ data, count = 5, path = '#', eventDataLayer, heading, layout = 'left' }) => {
  const cloneData = [...data.data].splice(0, count);
  const firstData = cloneData.shift();
  return (
    <div className='block-wrapper'>
      <div className='block-title'>
        <h2>{data.title}</h2>
        <a href={path} className='more'>
          ดูทั้งหมด <FiArrowRightCircle />
        </a>
      </div>
      <div className='row block-content'>
        {layout === 'left' && (
          <div className='col-lg-6 col-md-6'>
            <CardV
              data={firstData}
              path={firstData?.link}
              heading={heading}
              //! DATALAYER
              eventDataLayer={{
                ...eventDataLayer,
                data: {
                  ...eventDataLayer?.data,
                  title: firstData?.title,
                  index: 1
                }
              }}
            />
          </div>
        )}

        <div className='col-lg-6 col-md-6'>
          <ul className='block-list'>
            {cloneData.map((item, index) => (
              <li key={index}>
                <CardH
                  data={item}
                  large={false}
                  //! DATALAYER
                  eventDataLayer={{
                    ...eventDataLayer,
                    data: {
                      ...eventDataLayer?.data,
                      title: firstData?.title,
                      index: index + 2
                    }
                  }}
                />
              </li>
            ))}
          </ul>
        </div>
        {layout === 'right' && (
          <div className='col-lg-6 col-md-6'>
            <CardV
              data={firstData}
              path={firstData?.link}
              heading={heading}
              //! DATALAYER
              eventDataLayer={{
                ...eventDataLayer,
                data: {
                  ...eventDataLayer?.data,
                  title: firstData?.title,
                  index: 1
                }
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SectionHSide;
